import { Component, Input, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';

import {
  FormControl, ControlContainer, FormGroupDirective,
} from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
    selector: 'ngx-input-text',
    styleUrls: ['./input-text.component.scss'],
    templateUrl: './input-text.component.html',
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective,
        },
    ],
    standalone: false
})
export class InputTextComponent implements OnInit, OnDestroy {
  @Input() type: string = 'text';
  @Input() required: boolean = false;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() controlName: string;
  @Input() control: FormControl;
  @Input() maxlength: number = null;
  @Output() key = new EventEmitter<any>();

  private subscriptions: Subscription[] = [];
  MAX_INPUT_LENGTH = 9;

  ngOnInit() {
    if (this.type === 'number') {
      this.subscriptions.push(
        this.control.valueChanges.subscribe(value => {
          if (value && value.length > this.MAX_INPUT_LENGTH) {
            const oldValue = value.slice(0, 9);
            this.control.patchValue(oldValue);
          }
      }));
    }
  }

  onKeyDown(event) {
    if (this.type === 'number') {
      return event.keyCode !== 69;
    }
    return true;
  }

  onKeyUp(event) {
    if (event) {
      this.key.emit(event);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => {
      sub.unsubscribe();
    });
  }
}
